module.exports = __webpack_public_path__ + "static/media/tired.d6407e2f.svg";